import { cn } from '@/lib/utils';

export function ProgressiveQuestionReveal({ children, className }: React.ComponentProps<'div'>) {
  return (
    <div className={cn('animate-in duration-200 fade-in slide-in-from-top-2', className)}>
      {children}
    </div>
  );
}
